import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import ServiceList from "./ServiceList";
import ServiceAdd from "./ServiceAdd";
import ServiceDetail from "./ServiceDetail";
import ServiceBranch from "./ServiceBranch";
import ServiceAlbum from "./ServiceAlbum";
import ServiceStorage from "./ServiceStorage";
import ServiceMenuService from "./ServiceMenuService";
import ServiceModule from "./ServiceModule";
import ServiceAccount from "./ServiceAccount";
import ServicePayment from "./ServicePayment";
import ServicePackage from "./ServicePackage";
import { styles } from "./styles";
class Service extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { adminService = {} } = this.props;
    const disabled = adminService.userCode ? true : false;

    return (
      <Switch>
        <Route
          path="/service-admin/list"
          render={(props) => <ServiceList {...props} disabled={disabled} />}
        />
        <Route
          path="/service-admin/package"
          render={(props) => <ServicePackage {...props} disabled={disabled} />}
        />
        <Route
          path="/service-admin/add"
          render={(props) => <ServiceAdd {...props} disabled={disabled} />}
        />
        <Route
          path="/service-admin/detail"
          render={(props) => <ServiceDetail {...props} disabled={disabled} />}
        />
        <Route
          path="/service-admin/branch"
          render={(props) => <ServiceBranch {...props} disabled={disabled} />}
        />
        <Route
          path="/service-admin/album"
          render={(props) => <ServiceAlbum {...props} disabled={disabled} />}
        />
        <Route
          path="/service-admin/menu"
          render={(props) => (
            <ServiceMenuService {...props} disabled={disabled} />
          )}
        />
        <Route
          path="/service-admin/storage"
          render={(props) => <ServiceStorage {...props} disabled={disabled} />}
        />
        <Route
          path="/service-admin/owner"
          render={(props) => <ServiceAccount {...props} disabled={disabled} />}
        />
        <Route
          path="/service-admin/module"
          render={(props) => <ServiceModule {...props} disabled={disabled} />}
        />
        <Route
          path="/service-admin/payment"
          render={(props) => <ServicePayment {...props} disabled={disabled} />}
        />
      </Switch>
    );
  }
}

Service.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  adminService: state.service.adminService,
  role: state.user.user.roleId.role,
});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Service)));
